/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMessageRequest
 */
export interface CreateMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMessageRequest
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageRequest
     */
    senderId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageRequest
     */
    expenseId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMessageRequest
     */
    attachmentIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateMessageRequest interface.
 */
export function instanceOfCreateMessageRequest(value: object): value is CreateMessageRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('senderId' in value) || value['senderId'] === undefined) return false;
    if (!('expenseId' in value) || value['expenseId'] === undefined) return false;
    return true;
}

export function CreateMessageRequestFromJSON(json: any): CreateMessageRequest {
    return CreateMessageRequestFromJSONTyped(json, false);
}

export function CreateMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'senderId': json['senderId'],
        'expenseId': json['expenseId'],
        'attachmentIds': json['attachmentIds'] == null ? undefined : json['attachmentIds'],
    };
}

export function CreateMessageRequestToJSON(json: any): CreateMessageRequest {
    return CreateMessageRequestToJSONTyped(json, false);
}

export function CreateMessageRequestToJSONTyped(value?: CreateMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'senderId': value['senderId'],
        'expenseId': value['expenseId'],
        'attachmentIds': value['attachmentIds'],
    };
}

